export { default } from "use-force-update";
